import { render, staticRenderFns } from "./PaymentDescription.vue?vue&type=template&id=e1721dea&scoped=true"
import script from "./PaymentDescription.vue?vue&type=script&lang=ts"
export * from "./PaymentDescription.vue?vue&type=script&lang=ts"
import style0 from "./PaymentDescription.vue?vue&type=style&index=0&id=e1721dea&prod&lang=scss"
import style1 from "./PaymentDescription.vue?vue&type=style&index=1&id=e1721dea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1721dea",
  null
  
)

export default component.exports